'use strict';

const accordionRows = document.querySelectorAll('.accordion__title');
for (var i = accordionRows.length - 1; i >= 0; i--) {
	accordionRows[i].addEventListener('click', function(){
		this.parentNode.classList.toggle('active');
	})
}